import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative border border-gray-200 dark:border-gray-700 bg-white dark:bg-black rounded-lg shadow-xl max-w-md w-full" }
const _hoisted_3 = { class: "px-6 py-6" }
const _hoisted_4 = { class: "bg-gray-50 dark:bg-black rounded-lg p-4 space-y-2" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = { class: "text-sm font-medium text-red-600 dark:text-red-400" }
const _hoisted_13 = { class: "bg-gray-50 dark:bg-black border-t border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-end space-x-3" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "animate-spin h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_17 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}

import type { Tire } from '@/types/tire';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteTireModal',
  props: {
    isOpen: { type: Boolean },
    tire: {},
    loading: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.tire)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
            }, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "bg-red-50 dark:bg-red-900/20 border-b border-red-200 dark:border-red-800 px-6 py-4 flex items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0 w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mr-3" }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-6 w-6 text-red-600 dark:text-red-400",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        })
                      ])
                    ]),
                    _createElementVNode("h3", { class: "text-lg font-semibold text-red-900 dark:text-red-100" }, " Delete Tire Registration ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_3, [
                    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-gray-700 dark:text-gray-300 mb-4" }, " Are you sure you want to permanently delete this tire registration? ", -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Customer:", -1)),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.tire.user?.first_name) + " " + _toDisplayString(_ctx.tire.user?.last_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Pattern:", -1)),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.tire.pattern), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Size:", -1)),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.tire.tire_size), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Status:", -1)),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.tire.approval_status), 1)
                      ])
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mt-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4" }, [
                      _createElementVNode("p", { class: "text-sm text-red-800 dark:text-red-300" }, [
                        _createElementVNode("strong", null, "Warning:"),
                        _createTextVNode(" This action cannot be undone. All tire data and photos will be permanently deleted. ")
                      ])
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                      disabled: _ctx.loading,
                      class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, " Cancel ", 8, _hoisted_14),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm'))),
                      disabled: _ctx.loading,
                      class: "px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200 flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[9] || (_cache[9] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ])))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_17, _cache[10] || (_cache[10] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            }, null, -1)
                          ]))),
                      _createElementVNode("span", null, _toDisplayString(_ctx.loading ? 'Deleting...' : 'Delete Tire'), 1)
                    ], 8, _hoisted_15)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})